import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v3/data/tilakas/revoke-reasons';

class DataRevokeReason {
  index() {
    return Axios.get(API_URL);
  }

  show(id) {
    return Axios.get(API_URL + `/${id}`);
  }
}

export default new DataRevokeReason();



// WEBPACK FOOTER //
// ./src/api/DataRevokeReason.js